// ======================================================================
// File Name       : ChildUserList
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { Form, Col, Table } from 'react-bootstrap';

const ChildUserList = ({ userRelations, onHandleChecked }) => {
  const ChildUserListView = userRelations.map((userInfo, index) =>
    (<tr key={index}>
      <td className="text-center">
        <Form.Check
          type='checkbox'
          className="margin-clear"
          checked={userInfo.isChecked ? userInfo.isChecked : false}
          onChange={onHandleChecked.bind(this, userInfo.userSecernId)}
          disabled={(!userInfo.isNewChecked && userInfo.isChecked) || false} />
      </td>
      <td className="text-left">{userInfo.userName}</td>
      <td className="text-left">{userInfo.loginId}</td>
    </tr>),
  );
  return (
    <Col sm={12}>
      <Table striped hover>
        <thead>
          <tr>
            <th width="50" />
            <th>ユーザー名</th>
            <th>ログインID</th>
          </tr>
        </thead>
        <tbody>
          {ChildUserListView}
        </tbody>
      </Table>
    </Col>
  );
};

export default ChildUserList;
